<div id="top"></div>
<div class="container-fluid p-0">
    <!--Navbar-->

    <div class="topnav" id="myTopnav">

        <div class="container">
            <a class="navbar-brand mb-4">
                <img src="/assets/Image/logo.png" alt="" width="250" height="70">
            </a>
            <div class="nav mt-4" id="nav">
                <a id="home" routerLink="" (click)="topFunction()" (click)="closeNav()" title="Home">HOME</a>
                <a id="contact" (click)="closeNav()" class="active" title="Contact">CONTACT</a>
                <a id="contactUs" (click)="toContact()" (click)="closeNav()" title="Contact Us">CONTACT US</a>
                <a id="message" (click)="toMessage()" (click)="closeNav()" title="Send us a Message"> SEND US A
                    MESSAGE</a>

                <a id="adv" routerLink="../adventure" (click)="closeNav()" title="Contact">ADVENTURE</a>



                <a href="javascript:void(0);" class="icon" (click)="myFunction()" id="responsive">
                    <i class="fa fa-bars"></i>
                </a>
            </div>
        </div>
    </div>

    <!--/.Navbar-->

    <!--Nav Background Image-->


    <!--BG Image-->
    <div id="wrapper">
        <!--Text-->
        <h2 id="" class="text"><b><I>CONTACT US</I></b></h2>
        <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>By getting in touch with
                us.</i>
        </p>

    </div>

    <div class="bg"></div>
    <!--BG Image-->

    <!--/.Nav Background Image-->

    <!-- Contact Details-->
    <div id="toContact"></div>
    <br><br>
    <div align="center" class="phone">

        <div class="container">

            <div class="title">
                <h2 style="font-size: 40px;">CONTACT US</h2>
                <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>by
                        contacting...</i></p>
            </div>



            <div class="wrap">

                <!-- Call-->

                <div class="row justifycontent-center">

                    <!-- Call-->
                    <div class="col-sm-6 pb-2">

                        <!-- Card -->
                        <div>
                            <div class="view overlay">
                                <div class="icon"><i class="fas fa-phone-square-alt"></i></div>
                                <p>
                                    Mackson Chirwa – 066 063 9579 <br>
                                </p>

                            </div>
                        </div>
                        <!--/. Card -->
                    </div>
                    <!--/. Call-->

                    <!-- Text-->
                    <div class="col-sm-6 pb-2">
                        <!-- Card -->
                        <div>
                            <div class="icon"><i class="fas fa-envelope-square"></i></div>
                            <p>
                                Email Address: grandtraveladventures0@gmail.com
                            </p>
                        </div>
                        <!--/. Text-->

                    </div>
                </div>


                <!--/. Contact-->

            </div>
        </div>
    </div>
    <!-- /.Contact  Details-->


    <!-- Contact Form-->

    <div id="toMessage"></div>
    <div align="center" class="about">
        <div class="container">
            <div class="wrap">

                <!-- Call-->

                <div class="row justifycontent-center">

                    <!-- Call-->
                    <div class="col-sm-6 pb-2">

                        <!-- Card -->
                        <div>
                            <div class="view overlay">
                                <div class="title">
                                    <h2 style="font-size: 40px;">SEND US A MESSAGE</h2>
                                    <p
                                        style="font-size: 20px; color: #f79c09ce; font-family: cursive; font-size: 16px;">
                                        <i>if you are interested in our services.</i>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!--/. Card -->
                    </div>
                    <!--/. Call-->

                    <!-- Text-->
                    <div class="col-sm-6 pb-2">
                        <!-- Card -->
                        <div class="message">
                            <form action="" align="center" [formGroup]="contactForm">
                                <!--First Name-->
                                <div class="mb-1">
                                    <input mdbInput type="text" id="firstName" formControlName="firstName"
                                        placeholder="First Name:">

                                    <div *ngIf="firstName?.invalid && (firstName?.dirty || firstName?.touched)"
                                        class="text-danger">
                                        <small *ngIf="firstName?.errors?.required"> *First Name is required</small>
                                        <small *ngIf="firstName?.errors?.pattern"> *First Name must have letters
                                            only</small>
                                        <small *ngIf="firstName?.errors?.minlength"> *First Name must have to be more
                                            than 3 letter</small>
                                    </div>

                                </div>
                                <!--First Name-->

                                <!--Last Name-->
                                <div class="mb-1">
                                    <input mdbInput type="text" id="lastName" formControlName="lastName"
                                        placeholder="Last Name:">

                                    <div *ngIf="lastName?.invalid && (lastName?.dirty || lastName?.touched)"
                                        class="text-danger">
                                        <small *ngIf="lastName?.errors?.required"> *Last Name is required</small>
                                        <small *ngIf="lastName?.errors?.pattern"> *Last Name must have letters
                                            only</small>
                                        <small *ngIf="lastName?.errors?.minlength"> *Last Name must have to be more than
                                            3 letter</small>
                                    </div>

                                </div>
                                <!--Last Name-->

                                <!--Email Address-->
                                <div class="mb-1">
                                    <input mdbInput type="text" id="email" formControlName="email"
                                        placeholder="Email Address:">
                                    <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="text-danger">
                                        <small *ngIf="email?.errors?.required"> *Email address is required</small>
                                        <small *ngIf="email?.errors?.email"> *Invalid email address</small>
                                    </div>
                                </div>
                                <!--Email Address-->

                                <!--Phone Number-->
                                <div class="mb-1">
                                    <input mdbInput type="text" id="pNumber" formControlName="pNumber"
                                        placeholder="Phone Number:">
                                    <div *ngIf="pNumber?.invalid && (pNumber?.dirty || pNumber?.touched)"
                                        class="text-danger">
                                        <small *ngIf="pNumber?.errors?.required"> *Phone Number is required</small>
                                        <small *ngIf="pNumber?.errors?.pattern"> *Phone Number must be numbers. e.g.
                                            0790504555.</small>
                                    </div>
                                </div>
                                <!--Phone Number-->

                                <!--Message-->
                                <div class="mb-1">
                                    <textarea id="message" formControlName="message" placeholder="Message:"></textarea>

                                    <div *ngIf="message?.invalid && (message?.dirty || message?.touched)"
                                        class="text-danger">
                                        <small *ngIf="message?.errors?.required"> *Requires a message.</small>
                                    </div>
                                </div>
                                <!--Message-->

                                <!--Button-->
                                <button type="submit" [disabled]='!contactForm.valid' class="sendBtn"
                                    (click)="onSubmit()" (click)="frame.show()">SEND</button>
                                <button type="reset" class="resetBtn">RESET</button>
                            </form>
                        </div>

                        <!--After Submission-->

                        <div mdbModal #frame="mdbModal" class="modal fade left" id="frameModalTop" tabindex="-1"
                            role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header text-center">
                                        <h4 class="modal-title w-100 font-weight-bold"> Message</h4>

                                    </div>
                                    <div class="modal-body mx-3">
                                        <div class="md-form mb-5">
                                            <p align="center" style="top: 50%; margin-top: 50px;">Message has been sent.
                                            </p>

                                        </div>

                                        <button type="button" class="okBtn" (click)="frame.hide()"
                                            (click)="ok()">OK</button>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <!--After Submission-->
                        <!--/. Text-->

                    </div>
                </div>


                <!--/. Contact-->

            </div>


        </div>
    </div>
    <!-- /.Contact Form-->

    <!-- Footer -->
    <footer class="page-footer font-small">

        <!-- Footer Elements -->
        <div class="container">

            <!-- Grid row-->
            <div class="row">

                <!-- Grid column -->
                <div class="col-md-12 py-5">
                    <div class="mb-5 flex-center">

                        <!-- Facebook -->
                        <a class="fb-ic">
                            <mdb-icon fab icon="facebook" size="2x" class="white-text mr-md-5 mr-3"></mdb-icon>
                        </a>
                        <!-- Twitter -->
                        <a class="tw-ic">
                            <mdb-icon fab icon="twitter" size="2x" class="white-text mr-md-5 mr-3"></mdb-icon>
                        </a>
                        <!-- Google +-->
                        <a class="gplus-ic">
                            <mdb-icon fab fab icon="google-plus" size="2x" class="white-text mr-md-5 mr-3"></mdb-icon>
                        </a>

                        <!--Instagram-->
                        <a class="ins-ic">
                            <mdb-icon fab icon="instagram" size="2x" class="white-text mr-md-5 mr-3"></mdb-icon>
                        </a>

                    </div>
                </div>
                <!-- Grid column -->

            </div>
            <!-- Grid row-->

        </div>
        <!-- Footer Elements -->

        <!-- Copyright -->
        <div class="footer-copyright text-center py-3">© 2021 Copyright
        </div>
        <!-- Copyright -->

    </footer>
    <!-- Footer -->


    <button (click)="topFunction()" id="myBtn" title="Go to top"><i class="fas fa-arrow-up"></i></button>
</div>